import { ILabelValueOption } from "types";

import { STAT_DATA, STAT_VALUE, TEAM_TYPE, HOME_TEAM_SIDE } from "./types";

export const FIELD = {
  teamType: "teamType",
  action: "action",
  method: "method",
  bodyPart: "bodyPart",
  threat: "threat",
  succeed: "succeed",
  possession: "possession",
  homeTeamSide: "homeTeamSide",
  fromX: "fromX",
  fromY: "fromY",
  toX: "toX",
  toY: "toY",
  fromPlayer: "fromPlayer",
  toPlayer: "toPlayer",
  createdAt: "created_at",
  matchId: "matchid",
  teamId: "teamid",
  id: "id",
};

/* ------------------ DO NOT MODIFY VALUE ONLY IF REALLY NEED ! ---------------- */
export const EVENT_VALUES: STAT_VALUE = {
  PASS: 150,
  THROUGH: 152,
  DRIBBLE: 154,
  SHOOT: 172,
  TACKLE: 160,
  INTERCEPTION: 161,
  BLOCK: 162,
  CLEARANCE: 163,
  OFFSIDE: 164,
  SAVING: 165,
  OWN_GOAL: 166,
  FREE_KICK: 170,
  CORNER_KICK: 171,
  PENALTY: 102,
  FOUL: 105,
  YELLOW: 104,
  RED: 103,
};

export const EVENT_I18N_TAGS = {
  [EVENT_VALUES.PASS]: "STAT_ACTION_PASS",
  [EVENT_VALUES.THROUGH]: "STAT_ACTION_THROUGH",
  [EVENT_VALUES.DRIBBLE]: "STAT_ACTION_DRIBBLE",
  [EVENT_VALUES.SHOOT]: "STAT_ACTION_SHOOT",
  [EVENT_VALUES.TACKLE]: "STAT_ACTION_TACKLE",
  [EVENT_VALUES.INTERCEPTION]: "STAT_ACTION_INTERCEPTION",
  [EVENT_VALUES.BLOCK]: "STAT_ACTION_BLOCK",
  [EVENT_VALUES.CLEARANCE]: "STAT_ACTION_CLEARANCE",
  [EVENT_VALUES.OFFSIDE]: "STAT_ACTION_OFFSIDE",
  [EVENT_VALUES.SAVING]: "STAT_ACTION_SAVING",
  [EVENT_VALUES.OWN_GOAL]: "STAT_ACTION_OWNGOAL",
  [EVENT_VALUES.FREE_KICK]: "STAT_ACTION_FREE_KICK",
  [EVENT_VALUES.CORNER_KICK]: "STAT_ACTION_CORNER_KICK",
  [EVENT_VALUES.PENALTY]: "STAT_ACTION_PENALTY_KICK",
  [EVENT_VALUES.FOUL]: "STAT_ACTION_FOUL",
  [EVENT_VALUES.YELLOW]: "STAT_ACTION_YELLOW",
  [EVENT_VALUES.RED]: "STAT_ACTION_RED",
};

export const PASS_METHOD = {
  short: 1,
  long: 2,
  throwIn: 3,
};

export const SHOOT_METHOD = {
  insidePenalty: 1,
  outsidePenalty: 2,
};

export const TACKLE_METHOD = {
  normal: 1,
  sliding: 2,
};

export const FREEKICK_METHOD = {
  direct: 1,
  indirect: 2,
};

export const PASS_BODY_PART = {
  foot: 1,
  head: 2,
};

export const SHOOT_BODY_PART = {
  rightFoot: 1,
  leftFoot: 2,
  head: 3,
};

export const POSSESSION_TYPE = {
  win: "win",
  keep: "keep",
  lose: "lose",
};

export const PASS_DIRECTION = {
  unknown: 0,
  forward: 1,
  backward: 2,
  cross: 3,
};

/* ------------------ DO NOT MODIFY VALUE IF REALLY NEED ! END ---------------- */

export const STATS: STAT_DATA[] = [
  {
    name: "PASS",
    i18nTag: "STAT_ACTION_PASS_SHORT",
    category: "attack",
    shortcutKey: "q",
  },
  {
    name: "THROUGH",
    i18nTag: "STAT_ACTION_THROUGH_SHORT",
    category: "attack",
    shortcutKey: "w",
  },
  {
    name: "DRIBBLE",
    i18nTag: "STAT_ACTION_DRIBBLE_SHORT",
    category: "attack",
    shortcutKey: "r",
  },
  {
    name: "SHOOT",
    i18nTag: "STAT_ACTION_SHOOT_SHORT",
    category: "attack",
    shortcutKey: "y",
  },
  {
    name: "OFFSIDE",
    i18nTag: "STAT_ACTION_OFFSIDE_SHORT",
    category: "attack",
    shortcutKey: "u",
  },
  {
    name: "TACKLE",
    i18nTag: "STAT_ACTION_TACKLE_SHORT",
    category: "defence",
    shortcutKey: "a",
  },
  {
    name: "INTERCEPTION",
    i18nTag: "STAT_ACTION_INTERCEPTION_SHORT",
    category: "defence",
    shortcutKey: "s",
  },
  {
    name: "BLOCK",
    i18nTag: "STAT_ACTION_BLOCK_SHORT",
    category: "defence",
    shortcutKey: "d",
  },
  {
    name: "CLEARANCE",
    i18nTag: "STAT_ACTION_CLEARANCE_SHORT",
    category: "defence",
    shortcutKey: "f",
  },
  {
    name: "SAVING",
    i18nTag: "STAT_ACTION_SAVING_SHORT",
    category: "defence",
    shortcutKey: "g",
  },
  {
    name: "OWN_GOAL",
    i18nTag: "STAT_ACTION_OWNGOAL_SHORT",
    category: "defence",
    shortcutKey: "h",
  },
  {
    name: "FREE_KICK",
    i18nTag: "STAT_ACTION_FREE_KICK_SHORT",
    category: "setball",
    shortcutKey: "z",
  },
  {
    name: "CORNER_KICK",
    i18nTag: "STAT_ACTION_CORNER_KICK_SHORT",
    category: "setball",
    shortcutKey: "x",
  },
  {
    name: "PENALTY",
    i18nTag: "STAT_ACTION_PENALTY_KICK_SHORT",
    category: "setball",
    shortcutKey: "c",
  },
  {
    name: "FOUL",
    i18nTag: "STAT_ACTION_FOUL_SHORT",
    category: "foul",
    shortcutKey: "v",
  },
  {
    name: "YELLOW",
    i18nTag: "STAT_ACTION_YELLOW_SHORT",
    category: "foul",
    shortcutKey: "b",
  },
  {
    name: "RED",
    i18nTag: "STAT_ACTION_RED_SHORT",
    category: "foul",
    shortcutKey: "n",
  },
];

export const TEAM_OPTIONS: ILabelValueOption[] = [
  { i18nTag: "STAT_FORM_LABEL_HOME", value: TEAM_TYPE.HOME },
  { i18nTag: "STAT_FORM_LABEL_AWAY", value: TEAM_TYPE.AWAY },
];

export const STAT_METHOD_PASS_OPTIONS: ILabelValueOption[] = [
  { i18nTag: "STAT_PASS_SHORT", value: PASS_METHOD.short },
  { i18nTag: "STAT_PASS_LONG", value: PASS_METHOD.long },
  { i18nTag: "STAT_PASS_THROW_IN", value: PASS_METHOD.throwIn },
];

export const STAT_METHOD_PASS_BODY_PART_OPTIONS: ILabelValueOption[] = [
  { i18nTag: "STAT_PASS_FOOT", value: PASS_BODY_PART.foot },
  { i18nTag: "STAT_PASS_HEAD", value: PASS_BODY_PART.head },
];

export const STAT_RESULT_OPTIONS: ILabelValueOption[] = [
  { i18nTag: "STAT_RESULT_SUCCESS", value: true },
  { i18nTag: "STAT_RESULT_FAILED", value: false },
];

export const STAT_POSSESSION_OPTIONS: ILabelValueOption[] = [
  { i18nTag: "STAT_POSSESSION_WIN", value: POSSESSION_TYPE.win },
  { i18nTag: "STAT_POSSESSION_KEEP", value: POSSESSION_TYPE.keep },
  { i18nTag: "STAT_POSSESSION_LOSE", value: POSSESSION_TYPE.lose },
];

export const STAT_HOME_TEAM_SIDE: ILabelValueOption[] = [
  { i18nTag: "STAT_HOME_TEAM_LEFT", value: HOME_TEAM_SIDE.LEFT },
  { i18nTag: "STAT_HOME_TEAM_RIGHT", value: HOME_TEAM_SIDE.RIGHT },
];

export const STAT_METHOD_SHOOT_OPTIONS: ILabelValueOption[] = [
  { i18nTag: "STAT_SHOOT_IN_PENALTY", value: SHOOT_METHOD.insidePenalty },
  { i18nTag: "STAT_SHOOT_OUT_PENALTY", value: SHOOT_METHOD.outsidePenalty },
];

export const STAT_SHOOT_BODY_PART_OPTIONS: ILabelValueOption[] = [
  { i18nTag: "STAT_SHOOT_RIGHT_FOOT", value: SHOOT_BODY_PART.rightFoot },
  { i18nTag: "STAT_SHOOT_LEFT_FOOT", value: SHOOT_BODY_PART.leftFoot },
  { i18nTag: "STAT_SHOOT_HEAD", value: SHOOT_BODY_PART.head },
];

export const STAT_METHOD_TACKLE_OPTIONS: ILabelValueOption[] = [
  { i18nTag: "STAT_TACKLE_NORMAL", value: TACKLE_METHOD.normal },
  { i18nTag: "STAT_TACKLE_SLIDING", value: TACKLE_METHOD.sliding },
];

export const STAT_METHOD_FREEKICK_OPTIONS: ILabelValueOption[] = [
  { i18nTag: "STAT_FREEKICK_DIRECT", value: FREEKICK_METHOD.direct },
  { i18nTag: "STAT_FREEKICK_INDIRECT", value: FREEKICK_METHOD.indirect },
];

export const SWITCH_TEAM = "SWITCH";

export const SUBMIT_DATA = "SUBMIT";

export const POSSESSION_I18N_TAGS = {
  [POSSESSION_TYPE.win]: "STAT_POSSESSION_WIN",
  [POSSESSION_TYPE.keep]: "STAT_POSSESSION_KEEP",
  [POSSESSION_TYPE.lose]: "STAT_POSSESSION_LOSE",
};
